import { ComponentProps } from "react";
import type { NavigationItem } from "@app/types/Navigation";
import Card from "@particles/card/Card";
import VerticalsStories from "@routes/Home/Verticals/VerticalsStories";
import { sectionNavigationItems } from "@util/constant";
import { cn } from "@util/helpers";

type VerticalsProps = {
  /** Additionl styling for the component */
  className?: string;
  /** The list of the article card props */
  cardProps: ComponentProps<typeof Card>[];
};

const sections: NavigationItem[] = [
  sectionNavigationItems["international/asean"],
  sectionNavigationItems["international/global"],
  {
    ...sectionNavigationItems["startups-tech/startups"],
    label: "Inside the C-Suite",
  },
  sectionNavigationItems["singapore/smes"],
];

/**
 * Renders the Home - vertical section with a list of articles.
 * https://www.figma.com/design/rmzJoZwUpb3iLm6lMDXJ2W/BT-MASTER--WEB-?node-id=1312-2221&t=g7P8QlYHW3Ymfii6-4
 */
const Verticals = ({
  cardProps,
  className,
}: VerticalsProps): React.ReactElement => {
  return (
    <section
      className={cn(
        "stories md:grid md:grid-cols-2 md:gap-6 lg:grid-cols-4",
        className
      )}
      data-testid="homepage-verticals-stories-component"
    >
      {sections.map((section: NavigationItem, index: number) => {
        const card: ComponentProps<typeof Card> = cardProps[index];

        return (
          <VerticalsStories
            key={card.id}
            index={index}
            cardProps={card}
            section={section}
          />
        );
      })}
    </section>
  );
};

export default Verticals;
